/**
 * Collections API - Common Types
 *
 * Entity re-exports and shared schemas used across collection endpoints.
 */

import { z } from 'zod'
import {
  CollectionSchema,
  CollectionSummarySchema,
  CollectionMemberSchema,
  GuestAccessLinkSchema,
  RequestLinkSchema,
  CollectionTypeSchema,
  CollectionTypeDisplaySchema,
  CollectionVisibilitySchema,
  CollectionMemberRoleSchema,
  EmbedLayoutSchema,
  MediaTypeSchema
} from '../../schemas/entities/collection'

// Re-export entity schemas and types
export {
  CollectionSchema,
  CollectionSummarySchema,
  CollectionMemberSchema,
  GuestAccessLinkSchema,
  RequestLinkSchema,
  CollectionTypeSchema,
  CollectionTypeDisplaySchema,
  CollectionVisibilitySchema,
  CollectionMemberRoleSchema,
  EmbedLayoutSchema,
  MediaTypeSchema
}

export type {
  Collection,
  CollectionSummary,
  CollectionMember,
  GuestAccessLink,
  RequestLink,
  CollectionType,
  CollectionTypeDisplay,
  CollectionVisibility,
  CollectionMemberRole,
  EmbedLayout,
  MediaType
} from '../../schemas/entities/collection'

// ============================================================================
// Additional Collection Types
// ============================================================================

/**
 * Collection cover media info (for display in cards/lists)
 */
export const CollectionCoverMediaSchema = z.object({
  id: z.string(),
  url: z.string(),
  thumbnailUrl: z.string().nullable().optional(),
  mediaType: MediaTypeSchema,
  // Cloudinary URLs for display
  cloudinaryUrl: z.string().nullable().optional(),
  cloudinaryThumbnailUrl: z.string().nullable().optional(),
  // Mux playback id (SCH-1121) — additive. A Mux-backed VIDEO cover has NEITHER
  // Cloudinary field, so this is the only locator a client can derive its cover
  // frame from. Null for photos and legacy Cloudinary-era video rows.
  muxPlaybackId: z.string().nullable().optional()
})

export type CollectionCoverMedia = z.infer<typeof CollectionCoverMediaSchema>
